import { useState } from 'react';

const useCustomHook = () => {
  const [activeTab, setActiveTab] = useState('1');
  const [totalNum, setTotalNum] = useState(null);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [confirmingRow, setConfirmingRow] = useState(false);
  const [cancelingRequest, setCancelingRequest] = useState(false);

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedRowToDelete, setSelectedRowToDelete] = useState(null);
  const [isConfirmWithoutClientIdOpen, setIsConfirmWithoutClientIdOpen] = useState(false);
  const [selectedRowToConfirm, setSelectedRowToConfirm] = useState(null);

  const [filterParams, setFilterParams] = useState(null);


  const [dialogContent, setDialogContent] = useState({
    title: '',
    content: '',
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogForm, setOpenDialogForm] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [dialogAction, setDialogAction] = useState({});
  const [loadingAction, setLoadingAction] = useState(false);
  const [, setServiceSetsCols] = useState([]);







  return {
    page, setPage,
    size, setSize,
    setServiceSetsCols,
    dialogContent, setDialogContent,
    openDialog, setOpenDialog,
    openDialogForm, setOpenDialogForm,
    selectedRow, setSelectedRow,
    dialogAction, setDialogAction,
    loadingAction, setLoadingAction,
    filterParams, setFilterParams,
    activeTab,
    setActiveTab,
    loading,
    setLoading,
    confirmingRow,
    setConfirmingRow,
    cancelingRequest,
    setCancelingRequest,
    isConfirmOpen,
    setIsConfirmOpen,
    selectedRowToDelete,
    setSelectedRowToDelete,
    isConfirmWithoutClientIdOpen,
    setIsConfirmWithoutClientIdOpen,
    selectedRowToConfirm,
    setSelectedRowToConfirm,
    totalNum, setTotalNum,
    loading,
    setLoading,
  };
};

export default useCustomHook;
